
export const isCompleted = (vo) => {
  return !(vo.getIn(['response','data','attributes','not_found']) || vo.getIn(['response','data','attributes','permanently_closed']) )
};

export const getAtt = (vo,att) => {
  return vo.getIn(['response','data','attributes',att]);
}
